<template lang="pug">
  .business-list-file
    b-form
      b-form-file.base-input-file(
        ref="input-file"
        id="input-file"
        accept=".pdf"
        multiple
        @input="onUploadFiles"
        variant="secondary"
        placeholder="Subir Archivo"
        browse-text="Buscar"
        drop-placeholder="Suelta el archivo aquí"
      )
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    businessFolderId: Number
  },
  methods: {
    ...mapActions(['createBusinessFolderFile']),
    async onUploadFiles (files) {
      if(!files || files.length === 0) return
      const data = new FormData()
      for (const file of files) {
        data.append('file', file)
      }
      this.$refs['input-file'].reset()
      const response = await this.createBusinessFolderFile({ data, businessFolderId: this.businessFolderId})
      if (response.status >= 200 && response.status < 300) {
        this.$root.$bvToast.toast(`Se agregaron ${files.length} archivos`, {
          title: 'Agregado correcatamente',
          variant: 'success'
        })
      } else {
        this.$root.$bvToast.toast('No se pudo agregar el archivo', {
          title: 'Oops!!',
          variant: 'danger'
        })
      }
      this.$emit('done')
    },
    openInputFile () {
      document.getElementById('input-file').click()
    }
  }
}
</script>

<style lang="scss" scoped>
.base-input-file {
  display: none;
}
</style>
